import React from 'react';
import { WidgetProps } from '@rjsf/utils';
import { MarkdownContent } from '../markdown-content';
import { Widgets } from '@rjsf/bootstrap-4';

const BootstrapRadioWidget = Widgets.RadioWidget as React.ComponentType<any>;

export function RadioWidget({ options, ...props }: WidgetProps) {
  const enumOptions =
    Array.isArray(options.enumOptions) &&
    options.enumOptions.map((option) => {
      return {
        ...option,
        label: (
          <MarkdownContent components={{ p: 'span' }}>
            {option.label}
          </MarkdownContent>
        ),
      };
    });
  return (
    <BootstrapRadioWidget
      {...props}
      options={{
        ...options,
        /* @ts-ignore */
        enumOptions,
      }}
    />
  );
}
